import React from "react";
import { Input } from "../styled/Form";

const AddressSearch = ({
  value,
  onChangeText,
}: {
  value: string;
  onChangeText: (e: any) => void;
}) => {
  return (
    <>
      <Input
        placeholder="Type in the address"
        value={value}
        onChange={onChangeText}
        type="text"
      ></Input>
    </>
  );
};

export default AddressSearch;
